import { QualityStep, Step } from "@cs124/questioner-types";
import { Array, Boolean, Literal, Number, Partial, Record, String, Union } from "runtypes";
export const QualityConfiguration = Partial({
  points: Number,
  warn: Array(Step),
  fail: Array(QualityStep)
});
export const Lesson = Record({
  name: String,
  number: Number,
  date: String.withConstraint((s) => !isNaN(Date.parse(s))),
  available: String.withConstraint((s) => !isNaN(Date.parse(s))),
  start: String.withConstraint((s) => !isNaN(Date.parse(s))),
  deadline: String.withConstraint((s) => !isNaN(Date.parse(s))),
  semester: String,
  index: Number,
  path: String,
  title: String,
  description: String,
  language: Union(Literal("java"), Literal("kotlin")),
  modifiedDate: String.withConstraint((s) => !isNaN(Date.parse(s))),
  examples: Number
}).And(
  Partial({
    jsp: Record({
      name: String
    }).And(
      Partial({
        author: String,
        failOnLint: Boolean,
        quality: QualityConfiguration
      })
    )
  })
);
//# sourceMappingURL=index.js.map
